<template>
  <v-dialog
    v-model="active"
    max-width="800"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        outlined
        class="mr-4"
        color="grey darken-2"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left>
          search
        </v-icon>Search
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Previous appointments</v-card-title>

      <v-card-text>
        <v-select
          v-model="client"
          :items="sortedOptions"
          label="Select client"
          outlined
          return-object
          single-line
          hide-details
        >
          <template #item="{ item, on, attrs }">
            <v-list-item
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-avatar
                :color="item.color"
                class="white--text"
              >
                {{ item.initials }}
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle
                  class="captionxx"
                >
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template #selection="{ item, on, attrs }">
            <v-list-item
              v-bind="attrs"
              v-on="on"
            >
              <v-list-item-avatar
                :color="item.color"
                class="ml-n2 white--text"
              >
                {{
                  item.initials
                }}
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle
                  class="captionxx"
                >
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-card-text>
      <v-divider v-if="sortedAppointments.length > 0" />
      <v-list two-line>
        <div
          v-for="(appointment, i) in sortedAppointments"
          :key="appointment.id"
        >
          <v-list-item
            :to="`/consulting/${appointment.id}`"
            @click="active = false"
          >
            <v-list-item-avatar
              :color="appointment.client.color"
              class="white--text"
            >
              {{ appointment.client.initials }}
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ appointment.client.name }}</v-list-item-title>
              <v-list-item-subtitle
                class="captionxx"
              >
                {{ appointment.serviceName }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-layout ma-0>
                <v-chip
                  small
                  :color="_appointmentStatus(appointment.status).color"
                  class="ma-1"
                >
                  <v-icon left>
                    event
                  </v-icon>
                  {{ _appointmentStatus(appointment.status).text }}
                </v-chip>
                <v-chip
                  small
                  :color="_paymentStatus(appointment.paymentStatus).color"
                  class="ma-1"
                >
                  <v-icon left>
                    paid
                  </v-icon>
                  {{ _paymentStatus(appointment.paymentStatus).text }}
                </v-chip>
              </v-layout>
            </v-list-item-action>
            <v-list-item-action>
              <v-list-item-subtitle
                class="captionxx"
              >
                {{ _formatDateTime(appointment.start) }}
              </v-list-item-subtitle>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="i + 1 < appointments.length"
            inset
          />
        </div>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
// import { mapGetters } from 'vuex'
import { sortBy } from "lodash";
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";
import { db } from '@/plugins/firebase'
import mixins from "./mixins";

export default {
  mixins: [ mixins, helpers, binder ],
  props: {},
  data: () => ({
    active: false,
    clients: {},
    client: {},
    loading: {},
    appointments: [],
  }),
  computed: {
    sortedOptions() {
      return this._sortObject(this.clients)
      .map((c) => ({
        ...c,
        name: `${c.firstName} ${c.lastName}`,
        text: `${c.firstName} ${c.lastName}`,
        initials: this._initials([c.firstName, c.lastName]),
        color: this._emailToColor(c.email),
      }));
    },
    sortedAppointments() {
      return sortBy(this._mutateAppointments(this.appointments), ['start']);
    },
  },
  watch: {
    client(client = {}) {
      this.$unbindDb("appointments");
      const { email } = client 
      if (email) {
        const dbRef = db
          .collection(`services/consulting/appointments`)
          .where('client.email', '==', email)

        this.$bindDb("appointments", dbRef, { loader: "loading" });
      }
    },
    active(v) {
      if (v) {
        this.$bindDb("clients", "services/clients", { loader: "loading" });
      } else {
        this.$unbindDb("clients");
        this.client = {}
        this.appointments = []
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>